import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./CategoryDetail.css";
import { ImageGroup, Image } from "react-fullscreen-image";
import { BASE_URL } from "../../../../api";
import StickyVideoUp from "../../../StickyVideoUp";
import Loader from "../../../common/Loader";

function CategoryDetail() {
  const [detailImage, setDetailImage] = useState([]);
  const [heroimg, setHeroImg] = useState([]);
  const [isHeroLoading, setIsHeroLoading] = useState(true);
  const [isGalleryLoading, setIsGalleryLoading] = useState(true);
  const params = useParams();

  // category detail Image API
  useEffect(() => {
    fetch(`${BASE_URL}core/category_detail/?id=${params.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setHeroImg(data?.data);
        setIsHeroLoading(false);
        // console.log(data); // log the fetched data
      })
      .catch((err) => {
        console.log(err.message);
        setIsHeroLoading(false);
      });
  }, [params.id]);

  // List of Images API
  useEffect(() => {
    fetch(`${BASE_URL}core/camps_list/?category_id=${params.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setDetailImage(data?.data.reverse());
        setIsGalleryLoading(false);
        // console.log(data); // log the fetched data
      })
      .catch((err) => {
        console.log(err.message);
        setIsGalleryLoading(false);
      });
  }, [params.id]);

  return (
    <>
      <StickyVideoUp />
      {isHeroLoading ? (
        <Loader text="Loading camp details..." />
      ) : (
        <div className="CampsHero">
          <img src={heroimg.image1} alt="" />
        </div>
      )}
      <div className="ImageGalleryCamps">
        {isGalleryLoading ? (
          <Loader text="Loading camp gallery..." variant="inline" />
        ) : (
          <ImageGroup>
            <ul className="images">
              {detailImage.map((imageD) => (
                <li key={imageD.id} className="imagesDetailCams">
                  <Image
                    src={imageD.photo}
                    alt="Isbc camps"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                      zIndex: -1,
                    }}
                  />
                </li>
              ))}
            </ul>
          </ImageGroup>
        )}
      </div>
    </>
  );
}

export default CategoryDetail;
